import { PAGE_KEY } from './constants';

export const es = {
  [PAGE_KEY]: {
    // Mini header (task-06)
    MINI_HEADER_BACK_LABEL: 'Volver al listado de conceptos',

    // Meta row (task-06)
    META_CODE_LABEL: 'Código',
    META_TYPE_LABEL: 'Tipo',
    META_CFDI_LABEL: 'CFDI',
    META_RULE_TYPE_LABEL: 'Tipo de regla vigente',

    // Empty states (task-06)
    EMPTY_CONCEPT_NOT_FOUND_TITLE: 'No encontramos este concepto',
    EMPTY_CONCEPT_NOT_FOUND_DESCRIPTION:
      'El código de la URL no corresponde a ningún concepto del catálogo de tu organización.',
    EMPTY_CONCEPT_NOT_FOUND_ACTION: 'Volver al listado',

    // No-access gate state — added by task-06 per the orchestrator's "Gate de la
    // ruta" correction; this is a visibility gate, not a server-verified
    // permission (the authority is the save mutation's UserPermissionErrorResponse,
    // Task 13), so the copy never claims the permission was checked server-side.
    EMPTY_NO_ACCESS_TITLE: 'No tienes acceso a esta pantalla',
    EMPTY_NO_ACCESS_DESCRIPTION:
      'El editor de fórmulas está disponible solo para el equipo de soporte de Crehana.',

    // Error state (task-06)
    ERROR_TITLE: 'No pudimos cargar el concepto',
    ERROR_RETRY_BUTTON: 'Reintentar',

    // Discard dialog (task-07) — el flujo de descartar al cancelar se mantiene.
    RULES_DISCARD_DIALOG_TITLE: '¿Descartar los cambios sin guardar?',
    RULES_DISCARD_DIALOG_BODY:
      'Vas a cambiar de regla y perderás lo que escribiste en esta expresión.',
    RULES_DISCARD_DIALOG_CONFIRM: 'Descartar y continuar',

    // AST editor + echo (task-09)
    AST_TEXTAREA_LABEL: 'Expresión de la fórmula (AST)',
    AST_TEXTAREA_PLACEHOLDER:
      'Escribe aquí la fórmula en JSON, o inserta una referencia desde el panel.',
    AST_FORMAT_BUTTON: 'Formatear',
    AST_METRIC_NODES: '{{count}} nodos',
    AST_METRIC_DEPTH: 'profundidad {{depth}}/12',
    AST_METRIC_DEPENDENCIES: '{{count}} dependencias',
    ECHO_RAW_FALLBACK_HINT:
      'Esta expresión todavía no tiene la forma esperada — se muestra el JSON tal cual.',
    // Defecto 3 (post-review): copy propia sobre `JSON.parse`, conservando
    // la posición (única pista útil para ubicar el error en un JSON largo).
    AST_JSON_PARSE_ERROR:
      'JSON inválido — revisa el carácter cerca de la posición {{position}}.',
    // El motor no siempre reporta una posición (ej. "Unexpected end of JSON
    // input" en un JSON truncado) — nunca dejamos pasar el mensaje crudo en
    // inglés en ese caso.
    AST_JSON_PARSE_ERROR_GENERIC:
      'JSON inválido — revisa la sintaxis de la expresión.',

    // Validation panel (task-10, -9 keys en task-08 — AC-8: sólo se
    // renderizan filas con hallazgos, así que ninguna copia "todo en orden"
    // tiene consumidor).
    VALIDATION_SYNTAX_TITLE: 'Sintaxis',
    VALIDATION_SYNTAX_ERR_HINT: 'Error de sintaxis en {{path}}',
    VALIDATION_INCOMPLETE_TITLE: 'Fórmula incompleta',
    // AC-7: distinto de Sintaxis — el JSON es válido, sólo falta llenar datos.
    VALIDATION_INCOMPLETE_HINT: 'Faltan {{count}} valores por completar',
    VALIDATION_REFERENCES_TITLE: 'Referencias',
    VALIDATION_REFERENCES_WARN_HINT:
      'Hay una referencia válida que todavía no se puede calcular',
    VALIDATION_REFERENCES_ERR_HINT:
      'Hay una referencia que no existe o está mal escrita',
    VALIDATION_DEPENDENCIES_TITLE: 'Dependencias',
    // AC-6: un concepto que termina dependiendo de sí mismo.
    VALIDATION_DEPENDENCIES_ERR_HINT:
      'Esta fórmula crea una dependencia circular entre conceptos',
    VALIDATION_DEPTH_TITLE: 'Anidamiento',
    VALIDATION_DEPTH_WARN_HINT:
      'Se acerca al límite de anidamiento ({{depth}}/12)',
    VALIDATION_DEPTH_ERR_HINT: 'Supera el límite de anidamiento ({{depth}}/12)',
    VALIDATION_PCT_TITLE: 'Origen de datos',
    // AC-8: el backend acepta esta fórmula, por eso es warning y no bloquea guardar.
    VALIDATION_PCT_WARN_HINT:
      'Un campo "_pct" no se está dividiendo entre 100 — el resultado puede salir 100 veces más grande',

    // Reference panel (task-11)
    REF_PANEL_TITLE: 'Insertar referencia',
    REF_PANEL_SEARCH_PLACEHOLDER: 'Buscar por nombre de campo…',
    REF_PANEL_GROUP_CONTRACT: 'Contrato',
    REF_PANEL_GROUP_RUN: 'Corrida',
    REF_PANEL_GROUP_ACCUMULATOR: 'Acumulador',
    REF_PANEL_GROUP_FISCAL: 'Fiscal',
    REF_PANEL_GROUP_INCIDENCE: 'Incidencia',
    REF_PANEL_GROUP_CONCEPT: 'Concepto',
    // AC-9: integration_factor es el único campo deshabilitado — está en el
    // DSL pero el port no lo sirve (UNSERVED_CONTRACT_REF_FIELDS).
    REF_UNSERVED_TOOLTIP:
      'Este campo existe en el contrato, pero todavía no está disponible para fórmulas — usarlo hará que el guardado falle.',
    // B-4: el subtipo de ref.incidence es siempre "all", nunca editable.
    REF_INCIDENCE_SUBTYPE_TOOLTIP:
      'El subtipo siempre es "all": la captura de incidencias es texto libre, así que fijar un valor específico dejaría de coincidir en silencio ante cualquier variación de escritura.',

    // ref.contract — 12 campos (CONTRACT_REF_FIELDS)
    REF_CONTRACT_DAILY_WAGE: 'Salario diario',
    REF_CONTRACT_BASE_SALARY: 'Salario base',
    REF_CONTRACT_INTEGRATION_FACTOR: 'Factor de integración',
    REF_CONTRACT_WEEKLY_HOURS: 'Horas semanales',
    REF_CONTRACT_START_DATE: 'Fecha de ingreso',
    REF_CONTRACT_STATE_CODE: 'Estado',
    REF_CONTRACT_VACATION_DAYS: 'Días de vacaciones',
    REF_CONTRACT_CHRISTMAS_BONUS_DAYS: 'Días de aguinaldo',
    REF_CONTRACT_VACATION_PREMIUM_PCT: 'Prima vacacional',
    REF_CONTRACT_SENIORITY_YEARS: 'Años de antigüedad',
    REF_CONTRACT_PAY_FREQUENCY: 'Frecuencia de pago',
    REF_CONTRACT_IMSS_SALARY_TYPE: 'Tipo de salario IMSS',

    // ref.run — 7 campos (RUN_REF_FIELDS)
    REF_RUN_DAYS_WORKED: 'Días trabajados',
    REF_RUN_DAYS_PAID: 'Días pagados',
    REF_RUN_PERIOD_DAYS: 'Días del periodo',
    REF_RUN_PERIOD_START: 'Inicio del periodo',
    REF_RUN_PERIOD_END: 'Fin del periodo',
    REF_RUN_PAYMENT_DATE: 'Fecha de pago',
    REF_RUN_DAYS_BASE: 'Días base',

    // ref.accumulator — 4 campos (ACCUMULATOR_REF_FIELDS)
    REF_ACCUMULATOR_TAXABLE_INCOME_YTD: 'Ingreso gravable acumulado',
    REF_ACCUMULATOR_ISR_WITHHELD_YTD: 'ISR retenido acumulado',
    REF_ACCUMULATOR_SUBSIDY_APPLIED_YTD: 'Subsidio aplicado acumulado',
    REF_ACCUMULATOR_GROSS_INCOME_YTD: 'Ingreso bruto acumulado',

    // ref.fiscal — 5 tablas (FISCAL_REF_TABLES); el campo no tiene catálogo (B-5)
    REF_FISCAL_PARAMETERS: 'Parámetros',
    REF_FISCAL_ISR: 'ISR',
    REF_FISCAL_EMPLOYMENT_SUBSIDY: 'Subsidio al empleo',
    REF_FISCAL_IMSS_RATE: 'Tasa IMSS',
    REF_FISCAL_ISN_RATE: 'Tasa ISN',

    // ref.incidence — 9 tipos (INCIDENCE_REF_TYPES); los 8 campos se
    // muestran sin traducir (mismo criterio que `ruleType`).
    REF_INCIDENCE_ABSENTEEISM: 'Ausentismo',
    REF_INCIDENCE_DISABILITY: 'Incapacidad',
    REF_INCIDENCE_OVERTIME: 'Horas extra',
    REF_INCIDENCE_SAVINGS: 'Ahorro',
    REF_INCIDENCE_INFONAVIT: 'Infonavit',
    REF_INCIDENCE_FONACOT: 'Fonacot',
    REF_INCIDENCE_PENSION: 'Pensión',
    REF_INCIDENCE_RECURRING: 'Recurrente',
    REF_INCIDENCE_OTHER: 'Otro',

    // Defecto 2 (post-review): `example` en `concept-ast-catalog.ts` es un
    // ejemplo de formato, nunca un valor resuelto de empleado real (D-5) —
    // este prefijo evita que se lea como una lectura.
    REF_EXAMPLE_VALUE: 'ej. {{value}}',

    // Unidades (TAstReferenceFieldUnit) — token → copia humana
    UNIT_CURRENCY: 'moneda',
    UNIT_PERCENT: '%',
    UNIT_DAYS: 'días',
    UNIT_HOURS: 'horas',
    UNIT_DATE: 'fecha',
    UNIT_CATALOG: 'catálogo',
    UNIT_FACTOR: 'factor',
    UNIT_COUNT: 'conteo',

    // Vista read-only para reglas que no son FORMULA (task-12, AC-11)
    READONLY_TITLE: 'Esta regla no se edita desde aquí',
    READONLY_FIXED_DESCRIPTION:
      'Es una regla de monto fijo. Su valor se muestra a modo de referencia.',
    READONLY_MANUAL_INPUT_DESCRIPTION:
      'Es una regla de captura manual: no tiene una expresión que mostrar.',
    READONLY_TABLE_LOOKUP_DESCRIPTION:
      'Es una regla de tabla de búsqueda. Su expresión se muestra a modo de referencia.',
    READONLY_NO_EDIT_HINT:
      'El editor de fórmulas sólo admite reglas de tipo FORMULA.',

    // Guardado / footer / tabla de historial (task-13)
    BUTTON_CANCEL: 'Cancelar',
    BUTTON_SAVE: 'Guardar regla',
    TOAST_SAVED: 'Regla guardada',
    // AC-2 · AC-6: sólo el título — el cuerpo es el `message` del backend,
    // textual, nunca reescrito.
    VALIDATION_BACKEND_TITLE: 'No pudimos guardar esta regla',
    RULES_HISTORY_TABLE_TITLE: 'Historial de reglas',
    RULES_HISTORY_COLUMN_RULE_TYPE: 'Tipo',
    RULES_HISTORY_COLUMN_PRIORITY: 'Prioridad',
    RULES_HISTORY_COLUMN_VALID_FROM: 'Vigente desde',
    RULES_HISTORY_COLUMN_VALID_TO: 'Vigente hasta',
    // No está en la lista literal de claves del task — cubre la excepción de
    // red / respuesta inesperada, el único caso sin `message` del backend
    // (ver el guard `isExpressionInput` y el `catch` de
    // `use-save-concept-rule.ts`).
    SAVE_UNEXPECTED_ERROR: 'No pudimos guardar esta regla. Intenta de nuevo.',

    // task-03 — AC-2 grammar
    // Named-function operations (AC-2)
    OP_MAX: 'máx',
    OP_MIN: 'mín',
    OP_ROUND: 'redondear',
    OP_ABS: 'valor absoluto',
    OP_FLOOR: 'piso',
    OP_CEIL: 'techo',
    OP_ISR_LOOKUP: 'tabla de ISR',
    OP_SUBSIDY_LOOKUP: 'tabla de subsidio al empleo',
    OP_AND: 'y',
    OP_OR: 'o',
    OP_NOT: 'no',
    // Special forms
    OP_IF: 'si {{condition}} → {{then}} ; si no → {{else}}',
    OP_GET: '{{target}} → {{field}}',
    OP_DEPENDS_ON: 'depende de: {{list}}',
    // `get(...)` field names
    GET_FIELD_RETENCION: 'retención',
    GET_FIELD_SUBSIDIO: 'subsidio',
    // ref.fiscal — additive allowlist, NOT a validation catalog (B-10)
    REF_FISCAL_FIELD_UMA_DAILY: 'UMA diaria',
    REF_FISCAL_FIELD_EM_EXCEDENTE_3UMA: 'Excedente de 3 UMA',
    REF_FISCAL_FIELD_EM_PRESTACIONES_DINERO: 'Prestaciones en dinero',
    REF_FISCAL_FIELD_EM_GASTOS_MEDICOS_PENSIONADOS:
      'Gastos médicos de pensionados',
    REF_FISCAL_FIELD_IV_PRINCIPAL: 'Invalidez y vida',
    REF_FISCAL_FIELD_RCV_CESANTIA_VEJEZ: 'Retiro, cesantía y vejez',
    // ref.incidence fields — closed catalog (B-9)
    REF_INCIDENCE_FIELD_DAYS: 'Días',
    REF_INCIDENCE_FIELD_TOTAL_HOURS: 'Total de horas',
    REF_INCIDENCE_FIELD_HOURS_FACTOR_50: 'Horas al 50%',
    REF_INCIDENCE_FIELD_HOURS_FACTOR_100: 'Horas al 100%',
    REF_INCIDENCE_FIELD_HOURS_FACTOR_200: 'Horas al 200%',
    REF_INCIDENCE_FIELD_AMOUNT: 'Monto',
    REF_INCIDENCE_FIELD_PERCENTAGE: 'Porcentaje',
    REF_INCIDENCE_FIELD_COUNT: 'Conteo',

    // task-04 — AC-4 sources table
    SOURCES_TITLE: 'De dónde sale cada dato',
    SOURCES_COLUMN_DATA: 'Dato',
    SOURCES_COLUMN_ORIGIN: 'Origen',
    SOURCES_COLUMN_PATH: 'Ruta',
    SOURCE_CONCEPT_NO_RULE_TAG: 'Sin regla',
    SOURCE_CONCEPT_NO_RULE_HINT:
      'Este concepto no tiene ninguna regla cargada — no se puede calcular.',
    SOURCE_ORIGIN_CONTRACT: 'Contrato',
    SOURCE_ORIGIN_RUN: 'Corrida',
    SOURCE_ORIGIN_FISCAL: 'Tabla fiscal',
    SOURCE_ORIGIN_CONCEPT: 'Otro concepto',
    SOURCE_ORIGIN_ACCUMULATOR: 'Acumulado',
    SOURCE_ORIGIN_INCIDENCE: 'Incidencia',

    // task-05 — AC-2/AC-5 reading card
    READING_TITLE: 'Cómo se calcula',
    READING_CURRENT_RULE_TAG: 'Vigente desde {{validFrom}}',
    // task-08 (defecto post-task-07): reemplaza a los `EMPTY_NO_RULE_*` /
    // `EMPTY_NO_CURRENT_RULE_*` que el `EmptyState` de página completa,
    // borrado en task-07, dejó huérfanos — el editor sigue siendo
    // alcanzable, así que la llamada a la acción vive acá, no en un bloqueo
    // de página.
    READING_NO_FORMULA:
      'Este concepto todavía no tiene una fórmula. Escribe una para crear la primera regla.',

    // task-06 — AC-7 disclosure
    AST_DISCLOSURE_SHOW: 'Ver JSON',
    AST_DISCLOSURE_HIDE: 'Ocultar JSON',
    AST_DISCLOSURE_FINDINGS_BADGE: '{{count}} advertencia',
    AST_DISCLOSURE_FINDINGS_BADGE_plural: '{{count}} advertencias',

    // task-07 — AC-6 save sequence, AC-5 history marker
    SAVE_ANNOUNCE_TITLE: 'Antes de guardar',
    SAVE_ANNOUNCE_BODY:
      'La nueva versión regirá desde hoy ({{today}}) y la anterior se cerrará el {{yesterday}}.',
    SAVE_ANNOUNCE_FIRST_BODY:
      'Esta será la primera regla del concepto, vigente desde hoy ({{today}}).',
    SAVE_HISTORY_NOT_CLOSED_TITLE:
      'La regla nueva ya calcula, pero el historial quedó incompleto',
    // Deliberadamente NO dice "guarda de nuevo para arreglarlo": volver a
    // guardar crea una tercera regla y cierra sólo la segunda, dejando la
    // original abierta para siempre (memory.md Q-4) — no es una reparación.
    SAVE_HISTORY_NOT_CLOSED_BODY:
      'No pudimos cerrar la regla anterior. El cálculo ya usa la versión nueva, pero la anterior sigue abierta en el historial.',
    RULES_HISTORY_CURRENT_TAG: 'Vigente',
  },
};
